export default "__VITE_PUBLIC_ASSET__87e58376__"